import React from 'react';

const CastCrew = ({ actors = [], directors = [] }) => {
  if ((!actors || actors.length === 0) && (!directors || directors.length === 0)) {
    return null;
  }

  return (
    <div className="cast-crew mb-8">
      <div>
        <h3 className="text-white/70 font-medium mb-1">Cast</h3>
        <div className="flex flex-wrap gap-2">
          {actors.map(actor => (
            <span key={actor} className="bg-white/10 text-white px-3 py-1 rounded-full text-xs">
              {actor}
            </span>
          ))}
        </div>
        {directors?.[0] && (
          <>
            <h3 className="text-white/70 font-medium mb-1">Directors</h3>
            <div className="flex flex-wrap gap-2">
              {directors.map(director => (
                <span
                  key={director}
                  className="bg-white/10 text-white px-3 py-1 rounded-full text-xs"
                >
                  {director}
                </span>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CastCrew;
